<template>
  <div id="app">
    <TheHeader></TheHeader>
     <transition name="fade" mode="out-in">
        <router-view class="view"></router-view>
     </transition>
    <TheTradeAssociations></TheTradeAssociations>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import jquery from "./assets/lib/jquery/jquery.min.js";
import bootstrap from "./assets/lib/bootstrap/js/bootstrap.min.js";
import owlcarousel from "./assets/lib/owlcarousel/owl.carousel.min.js";
import stellar from "./assets/lib/stellar/stellar.min.js";
import custom from "./assets/js/custom.js";
import colorswitcher from "./assets/js/color-switcher.js";
import TheHeader from "@/components/layout/TheHeader";
import TheFooter from '@/components/layout/TheFooter'
import TheTradeAssociations from '@/components/layout/TheTradeAssociations'

export default {
  name: "App",
  components: {
    TheHeader,
    TheFooter,
    TheTradeAssociations
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Roboto:400,100,300,500,700,900");
@import url("./assets/lib/bootstrap/css/bootstrap.min.css");
@import url("./assets/lib/font-awesome/css/font-awesome.min.css");
@import url("./assets/lib/owlcarousel/owl.carousel.min.css");
@import url("./assets/lib/owlcarousel/owl.theme.default.min.css");
@import url("./assets/lib/owlcarousel/owl.transitions.min.css");
@import url("./assets/css/style.css");
@import url("./assets/css/colour-red.css");
@import url("./assets/css/custom-style.css");
</style>



// WEBPACK FOOTER //
// src/App.vue